export default class AudioVisualizer {
  canvas: HTMLCanvasElement
  analyser: AnalyserNode
  freqs: Uint8Array

  constructor(selector: string, analyserNode: AnalyserNode) {
    this.analyser = analyserNode
    this.freqs = new Uint8Array(this.analyser.frequencyBinCount);

    const parent = document.querySelector(selector)
    const canvas = document.createElement('canvas')
    canvas.width = parent.offsetWidth
    canvas.height = canvas.width * 0.75
    parent.appendChild(canvas)
    this.canvas = canvas

    requestAnimationFrame(this.draw.bind(this))
  }

  draw() {
    this.analyser.getByteFrequencyData(this.freqs);

    const canvas = this.canvas
    const ctx = canvas.getContext('2d')
    ctx.clearRect(0, 0, canvas.width, canvas.height)

    // Draw the frequency domain chart.
    const bins = this.analyser.frequencyBinCount
    const xMin = 20 * Math.log10(Math.PI / bins)
    const xMax = 20 * Math.log10(Math.PI)
    const yMin = this.analyser.minDecibels
    const yMax = this.analyser.maxDecibels

    let prevX = 0
    for (var i = 0; i < bins; i++) {
      let percent = this.freqs[i] / 256.0;
      let omega = (i / bins) * Math.PI
      let xLog = 20 * Math.log10(omega)
      let x = (xLog - xMin) / (xMax - xMin) * canvas.width

      let dB = yMin + percent * (yMax - yMin)
      let yLog = 20 * Math.log10(1 + percent)
      let y = (yLog - 1) * canvas.height
      let height = canvas.height * percent;
      let offset = canvas.height - height - 1;

      let barWidth = x - prevX
      let hue = i / this.analyser.frequencyBinCount * 360
      //ctx.fillStyle = 'yellow'
      ctx.fillStyle = 'hsl(' + hue + ', 100%, 50%)'
      ctx.fillRect(x, offset, barWidth, height)
      prevX = x
    }
    requestAnimationFrame(this.draw.bind(this))
  }
}



// WEBPACK FOOTER //
// ./src/AudioVisualizer.ts